import { Property } from '@greystar/lib';
import { PropertyDetailsOverviewProps } from '@greystar/ui';
import { GetStaticComponentProps, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import React, { JSX } from 'react';
import {
  Grid,
  LayoutContainer,
  PageSectionContent,
  Header,
  BodyCopy,
  PageSection,
} from '@greystar/designsystem';

const PropertyDetailsOverview = (props: PropertyDetailsOverviewProps): JSX.Element => {
  if (!props.data?.overviewText) {
    return <></>;
  }

  return (
    <PageSection isTopFlushed>
      <PageSectionContent className="pt-[20px] md:pt-[32px]">
        <Grid>
          <Grid.Item smColumnSpan={4} mdColumnSpan={8} lgColumnSpan={10}>
            <LayoutContainer flexDirection="column" gap="xs">
              <Header component="h2" className="mb-[4px]">
                Building overview
              </Header>
              <BodyCopy>{props.data.overviewText}</BodyCopy>
            </LayoutContainer>
          </Grid.Item>
        </Grid>
      </PageSectionContent>
    </PageSection>
  );
};

export const getStaticProps: GetStaticComponentProps = async (
  rendering,
  layoutData
): Promise<PropertyDetailsOverviewProps> => {
  const props = rendering as unknown as PropertyDetailsOverviewProps;
  const property = layoutData.sitecore.context.property as Property;

  if (!property) {
    return {
      ...props,
      data: {
        overviewText: undefined,
        notFound: true,
      },
    };
  }

  return {
    ...props,
    data: {
      overviewText: property?.about?.longDescription,
      notFound: false,
    },
  };
};

export default withDatasourceCheck()<PropertyDetailsOverviewProps>(PropertyDetailsOverview);
